module.exports = __webpack_public_path__ + "img/copyright.458c50e1.svg";